export default class SimpleStoreProduct {
  public id!: number
  public name!: string
  public price!: number
}
